import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { TimeAllocationConcept, CacheService } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TimeAllocationConceptService {

  className = 'TimeAllocationConceptService';

  constructor(private http: HttpClient, private translateService: TranslateService, private cacheService: CacheService) { }

  getAllConcepts(cache = true, cacheKey = "allImputationConcepts"): Observable<TimeAllocationConcept[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<TimeAllocationConcept[]>(environment.base_URL + "/types-imputation-concepts").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getActivities(): Observable<TimeAllocationConcept[]> {
    return this.getAllConcepts().pipe(map(result => {
      return result.filter(item => item.imputablePai);
    }));
  }

  findActivities(params) {
    return this.http.get<any>(environment.base_URL + "/filtered-imputations", { params });
  }


  getFatherActivities(): Observable<TimeAllocationConcept[]> {
    return this.getAllConcepts().pipe(map(result => {
      _.remove(result, (item: any) => item.typeConceptImputationFatherId);
      //let filteredData = _.filter(result, item => item.imputablePai);
      _.forEach(result, item => {
        item.imputationsChildren = _.map(item.imputationsChildren, elem => elem.idTypeConceptImputationPk);
      })
      result = _.filter(result, item => item.txtTypeConceptImputation?.toLowerCase() !== 'trabajos');
      _.forEach(result, (item: any) => {
        this.translateService.stream(item.txtTypeConceptImputation).subscribe(translate => {
          item.txtTypeConceptImputationTranslate = translate;
        });
      });

      return result;
    }));
  }

  getChildrenActivities(): Observable<TimeAllocationConcept[]> {
    return this.getAllConcepts().pipe(map(result => {
      //const filtered = _.filter(result, item => item.imputablePai);
      const childrens = _.filter(result, (item: any) => item.typeConceptImputationFatherId);
      const data = _.reduce(_.map(result, item => { return { [item.idTypeConceptImputationPk as number]: item } }), (prev, next) => _.assign(prev, next));
      _.forEach(childrens, child => {
        this.translateService.stream(data![child.typeConceptImputationFatherId].txtTypeConceptImputation!).subscribe(translate1 => {
          this.translateService.stream(child.txtTypeConceptImputation).subscribe(translate2 => {
            child.txtTypeConceptImputationTranslate = `${translate1} / ${translate2}`;
          });
        });

      });
      return childrens;
    }));
  }


  newConcept(concept) {
    return this.http.post(environment.base_URL + "/types-imputation-concepts", concept);
  }

  updateConcept(concept, id) {
    return this.http.put(environment.base_URL + `/types-imputation-concepts/${id}`, concept)
  }

  deleteConcept(id: number) {
    return this.http.delete(environment.base_URL + `/types-imputation-concepts/${id}`)
  }
}
